import { ViewSidebarBlock } from "./view-sidebar-block";
import { ViewColumn } from "./view-column";

export { ViewSidebarBlock, VIEW_SIDEBAR_FIELDS_BLOCK } from "./view-sidebar-block";

export type ViewSidebarTrigger = "select" | "double-click";
export type ViewSidebarPosition = "left" | "right";

export class ViewSidebar {
	Enabled:boolean = false;
	Trigger:ViewSidebarTrigger = "select";
	Position:ViewSidebarPosition = "right";
	Width:number = 380;
	Blocks:ViewSidebarBlock[] = [];
	TitleField:ViewColumn | null = null;
	SubtitleFields:ViewColumn[] = [];

	constructor(data?:any) {
		if (!data) return;
		this.TitleField = data.TitleField ? new ViewColumn(data.TitleField) : null;
		this.SubtitleFields = (data.SubtitleFields || []).map((f:any)=>new ViewColumn(f));
		this.Enabled = data.Enabled || false;
		this.Trigger = data.Trigger == "double-click" ? "double-click" : "select";
		this.Position = data.Position == "left" ? "left" : "right";
		this.Width = data.Width || 380;
		this.Blocks = (data.Blocks || []).map((b:any)=>new ViewSidebarBlock(b));
	}

	get opensOnSelect():boolean {
		return this.Enabled && this.Trigger == "select";
	}

	get opensOnDoubleClick():boolean {
		return this.Enabled && this.Trigger == "double-click";
	}

	getHeaderFields():ViewColumn[] {
		let result:ViewColumn[] = [];
		if (this.TitleField) result.push(this.TitleField);
		result.push(...this.SubtitleFields);
		return result;
	}

	getPreloads():string[] {
		let result:string[] = [];
		for (let block of this.Blocks) {
			result.push(...block.getPreloads());
		}
		for (let field of this.getHeaderFields()) {
			let parts = field.Property.split(".");
			if (parts.length > 1) {
				parts.pop();
				result.push(parts.join("."));
			}
			if (field.IsComputed) {
				result.push(...(field.ComputedPreloads || []));
			}
		}
		return result.filter(p=>p != "").filter((p, i, arr)=>arr.indexOf(p) == i);
	}

	getJSON():any {
		return {
			Enabled: this.Enabled,
			Trigger: this.Trigger,
			Position: this.Position,
			Width: this.Width,
			Blocks: this.Blocks.map(b=>b.getJSON()),
			TitleField: this.TitleField,
			SubtitleFields: this.SubtitleFields
		};
	}
}
